import script from "./SharedSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./SharedSpinner.vue?vue&type=style&index=0&id=69aca16e&lang=postcss"

const __exports__ = script;

export default __exports__